import {useState} from "react";

export default function SkodaDataInfo() {
    const [openInfo, setOpenInfo] = useState(false);
    return (
        <div className="form-info-container">
            <div className="form-info">
                <p onClick={() => setOpenInfo(!openInfo)} className="more-info more-info-link js-btn-more-info"
                   data-status="0">Zobacz więcej</p>
                {openInfo &&
                    <div className="more-info js-more-info">
                        1) <b>(Twoje) Dane: przetwarzamy następujące dane</b>: adres email oraz imię i nazwisko, jeśli
                        je podasz
                        żebyśmy mogli personalizować Newsletter;
                        <br/><br/>
                        2) <b>Cele i podstawy prawne</b>:
                        <ul>
                            <li>wysyłania Newslettera zawierającego w/w informacje handlowe i marketingowe na
                                podstawie Twojej
                                zgody;
                            </li>
                            <li>realizacji usługi świadczonej drogą elektroniczną w zakresie obsługi subskrypcji
                                Newslettera,
                                możliwych w tym zakresie reklamacji (tj. w ramach umowy o świadczenie usługi drogą
                                elektroniczną) oraz zapewnienia bezpieczeństwa korzystania z usługi świadczonej
                                drogą
                                elektroniczną w ramach uzasadnionego interesu VGP (więcej w Regulaminie
                                Newslettera).
                            </li>
                            <li>w celach archiwalnych (dowodowych) będących realizacją naszego prawnie uzasadnionego
                                interesu
                                dotyczącego zabezpieczenia informacji na wypadek prawnej potrzeby wykazania faktów,
                                ewentualnego
                                ustalenia, dochodzenia lub obrony przed roszczeniami;
                            </li>
                            <li>w celach analitycznych i statystycznych - lepszego doboru produktów i usług do
                                potrzeb naszych
                                klientów, ogólnej optymalizacji naszych produktów, optymalizacji procesów obsługi,
                                budowania
                                wiedzy o naszych klientach, będącego realizacją naszego prawnie uzasadnionego
                                interesu;
                            </li>
                            <li>w celu realizacji Twoich praw i reklamacji, aktualizacji Twoich danych, prowadzenia
                                bazy
                                subskrybentów; będących realizacją naszego prawnie uzasadnionego interesu
                            </li>
                        </ul>
                        <br/>
                        3) <b>W związku z korzystaniem przez Ciebie ze strony internetowej marki</b> Škoda
                        gromadzi także
                        informacje zawarte w plikach cookies lub podobnych technologiach w celu analizowania
                        zachowań, lepszego
                        dostosowania oferty produktów lub usług oraz wyświetlania reklamy produktów lub usług
                        marki w oparciu o
                        Twoją aktywność i zainteresowania w Internecie. Jeśli chciałbyś cofnąć swoją zgodę w
                        zakresie
                        korzystania przez nas z cookies lub podobnych technologii należy przede wszystkich
                        dokonać zmian
                        ustawień przeglądarki. Więcej w naszej <a
                        href="http://www.skoda-auto.pl/inne/polityka-prywatnosci" target="_parent">Polityce
                        prywatności</a> oraz Polityce cookies <a href="http://www.skoda-auto.pl/inne/polityka-plikow-cookies"
                                                                 target="_parent">Polityce cookies</a>.
                        <br/>
                        4) <b>Kontakt z inspektorem ochrony danych VGP</b>: Możesz skontaktować się z IOD
                        VGP pod adresem e-mail
                        iod@vw-group.pl, a także pisemnie na adres Volkswagen Group Polska sp. z o.o. z
                        siedzibą w Poznaniu
                        (61-037), ul. Krańcowa 44 z dopiskiem „IOD”;
                        <br/>
                        5) <b>Odbiorcy danych</b>: firmy świadczące usługi na nasze zlecenie, którym
                        zlecimy czynności
                        wymagające przetwarzania danych, w szczególności w zakresie usług IT,
                        prowadzenia strony internetowej,
                        realizacji wysyłki Newslettera, usług marketingowych (m.in. agencje
                        marketingowe), call center
                        <br/>
                        6) <b>Okres przechowywania</b>: Twoje dane osobowe przetwarzane będą w celu
                        otrzymywania Newslettera do
                        czasu rezygnacji z subskrypcji. Dodatkowo do chwili przedawnienia roszczeń
                        będziemy przechowywać dowód
                        udzielonej przez Ciebie zgody oraz dane związane z korzystaniem z usługi
                        świadczonej drogą elektroniczną
                        dla celów dowodowych – wykazania faktów na wypadek ewentualnych roszczeń
                        związanych z przetwarzaniem
                        danych osobowych. W odniesieniu do pozostałych celów opartych na naszym
                        uzasadnionym interesie przez
                        okres ważności tych celów albo do czasu wniesienia przez Ciebie sprzeciwu, w
                        każdym przypadku nie dłużej
                        niż 5 lat;<br/>
                        7) <b>Pouczenie o prawach</b>: masz prawo dostępu do treści swoich danych
                        oraz prawo ich sprostowania,
                        usunięcia, ograniczenia przetwarzania, prawo do przenoszenia danych, prawo
                        do cofnięcia zgody w dowolnym
                        momencie poprzez kliknięcie linka dezaktywującego subskrypcję umieszczonego
                        w każdej wiadomości z
                        Newsletterem; cofnięcie zgody pozostaje bez wpływu na zgodność z prawem
                        przetwarzania Twoich danych,
                        którego dokonano na podstawie zgody przed jej cofnięciem. Możesz zrealizować
                        swoje prawa m.in. przez
                        kontakt na adres email: daneosobowe@vw-group.pl;
                        <br/>
                        8) <b>Prawo do wniesienia sprzeciwu</b>: masz prawo do wniesienia
                        sprzeciwu wobec przetwarzania Twoich
                        danych w związku z celami opartymi na podstawie naszego prawnie
                        uzasadnionego interesu, opisanego
                        powyżej ( w takim przypadku przestaniemy przetwarzać Twoje dane w tych
                        celach, chyba że będziemy w
                        stanie wykazać, że w stosunku do tych danych istnieją dla nas ważne
                        prawnie uzasadnione podstawy, które
                        są nadrzędne wobec Twoich interesów, praw i wolności, lub dane będą nam
                        niezbędne do ewentualnego
                        ustalenia, dochodzenia lub obrony roszczeń). Masz prawo do wniesienia
                        sprzeciwu wobec marketingu. Nie
                        stosujemy zautomatyzowanego podejmowania decyzji czy profilowania w
                        zakresie treści prezentowanych w
                        Newsletterze.
                        <br/>
                        9) <b>Prawo do skargi</b>: masz prawo wniesienia skargi do Prezesa
                        Urzędu Ochrony Danych Osobowych,
                        jeśli uznasz, że przetwarzanie danych osobowych narusza przepisy o
                        ochronie danych osobowych;
                        <br/>
                        10) Jeśli w ramach przetwarzania Twoje dane osobowe będą przekazywane do odbiorców w krajach trzecich (poza EOG), takie przekazywanie danych może odbywać się na podstawie decyzji w sprawie odpowiedniego stopnia ochrony podjętej przez Komisję Europejską lub na podstawie standardowych klauzul umownych zgodnie z decyzją Komisji Europejskiej albo na podstawie Pana/Pani wyraźnej zgody. Więcej informacji w tym zakresie można uzyskać kontaktując się z IOD VGP.
                        <p style={{textDecoration: "underline", cursor: "pointer"}} onClick={() => setOpenInfo(false)} className="js-btn-more-info">Zwiń</p>
                    </div>
                }
            </div>
        </div>
    );
}
